import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";

export default class SMS extends Component {
  constructor() {
    super();
    this.state = {
      words: 0,
      credit: 1,
      showContact: "none",
      data: [],
      showInvoice: "none",
      btnDisable: false,
      formError: false,
    };
  }
  handleChange = (e) => {
    if (e.target.name === "group") {
      if (e.target.value === "custom") {
        this.setState({ showContact: true, showInvoice: "none" });
      } else if (e.target.value === "invoice") {
        this.setState({ showInvoice: true, showContact: true });
      } else {
        this.setState({ showContact: "none", showInvoice: "none" });
      }
    }
    if (e.target.name === "message") {
      this.setState({
        words: e.target.value.length,
        credit: Math.ceil(e.target.value.length / 160),
      });
    }
    const newData = { ...this.state.data };
    newData[e.target.name] = e.target.value;
    this.setState({ data: newData });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    let formData = new FormData();
    formData.append("type", this.state.data.group || "");
    formData.append("contact", this.state.data.contact || "");
    formData.append("invoice", this.state.data.invoice || "");
    formData.append("message", this.state.data.message || "");
    ApiConnect({
      method: "post",
      url: "/Module/Utilities/Notification/SMS",
      data: formData,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({
            formError: response.data.message,
          });
        }
      })
      .catch((error) => console.error(error));
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card shadow-1">
          <h4 className="card-title">
            <strong>SMS</strong> Sender
          </h4>
          <div className="card-body">
            <form onSubmit={(e) => this.handleSubmit(e)}>
              <p className="text-danger">{this.state.formError}</p>
              <div className="row">
                <div className="form-group col-md-6">
                  <label className="require">Select Contacts Group</label>
                  <select
                    className="form-control"
                    name="group"
                    required
                    onChange={(e) => this.handleChange(e)}
                  >
                    <option value="">Select Contacts</option>
                    <option value="allcustomer">All Customers</option>
                    <option value="verifycustomer">Verifired Customers</option>
                    <option value="allemployee">All Employee</option>
                    <option value="workingemployee">Working Employee</option>
                    <option value="invoice">Invoice</option>
                    <option value="custom">Custom</option>
                  </select>
                </div>
                <div
                  className="form-group col-md-6"
                  style={{ display: this.state.showContact }}
                >
                  <label className="require">
                    Custom Contact <small>(1234567890,Comma Separated )</small>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="contact"
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                <div
                  className="form-group col-md-6"
                  style={{ display: this.state.showInvoice }}
                >
                  <label className="require">Invoice Details</label>
                  <input
                    className="form-control"
                    type="text"
                    name="invoice"
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="form-group mt-3">
                <label className="require">Message</label>
                <textarea
                  rows="5"
                  name="message"
                  required
                  onChange={(e) => this.handleChange(e)}
                  className="form-control"
                ></textarea>
                <div className="alert alert-info" role="alert">
                  Total Characters: {this.state.words} Credit:{" "}
                  {this.state.credit}
                </div>
              </div>
              <footer className="card-footer text-left">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={this.state.btnDisable}
                >
                  Submit
                </button>
              </footer>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
